<template>
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item >设备管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 设备分布 -->
     <div class="equipment-distribution" v-if="showEquipDis==true">
        <!-- <dv-border-box-12 style="padding: 6px 0px 6px 0px;"> -->
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">设备分布</div>
          </div>
          <div class="header-common-right">
            <el-button
              class="right-button-export"
              @click="exportDisTable"
              type="text"
              >
              导出
            </el-button>
          </div>
        </div>
        <div class="distribution-list">
          <el-table
            v-loading='loading1'
            :data="distributionData"
            :max-height="230"
            style="width: 100%"
            border
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderCellStyle"
             @cell-click="showMoreDetailConsumables"
            >
            <el-table-column
              type="index"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="provinceName"
              label="所在地区">
            </el-table-column>
            <el-table-column
              prop="hospitalAmount"
              label="使用单位数量"
              sortable
              >
            </el-table-column>
            <el-table-column
              prop="equipmentAmount"
              label="设备数量">
            </el-table-column>
            <el-table-column
              prop="consumableUsedAmount"
              label="耗材消耗">
            </el-table-column>
          </el-table>
        </div>
        <!-- </dv-border-box-12> -->
      </div>

      <!-- 设备列表 -->
      <div class="table-content">
            <div class="header-common" >
              <div class="header-common-left">
                <div class="title">设备列表</div>
              </div>
              <div class="header-common-right">
                <el-button
                  class="right-button-export"
                  @click="exportTable"
                  type="text"
                  v-if="showActionExport==true"
                  >
                  导出
                </el-button>
                <router-link
                v-if="showActionAdd==true"
                class="right-button-base"
                :to="{path:'/manage/equipment/equipment-add'}">
                  设备注册
                </router-link>
              </div>
            </div>
            <div class="table-list">
              <el-table
              v-loading='loading2'
                border
                :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderCellStyle"
                :max-height="tableHeight"
                :data="tableData.filter(data => !search || data.provinceName.toLowerCase().includes(search.toLowerCase()) || data.hospitalName.toLowerCase().includes(search.toLowerCase()) || data.udi.toLowerCase().includes(search.toLowerCase()) || data.type.toLowerCase().includes(search.toLowerCase()) || data.statusText.toLowerCase().includes(search.toLowerCase()))"

                >

                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  label="所在地区"
                  >
                  <template slot-scope="scope">
                    <span>{{scope.row.provinceName}}/{{scope.row.cityName}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="hospitalName"
                  label="使用单位">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="点击可查看医使用单位详情" placement="top-start" v-if="scope.row.hospitalName!='--'">
                      <router-link
                        style="text-decoration: none;color: #fff;"
                        :to="{path:'/manage/equipment/equipment-hospital-one',query:{id:scope.row.hospitalId}}">
                        {{scope.row.hospitalName}}
                      </router-link>
                    </el-tooltip>
                    <span v-else>{{scope.row.hospitalName}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="typeName"
                  label="产品名称">
                </el-table-column>
                <el-table-column
                  prop="typeModel"
                  label="规格型号">
                </el-table-column>
                <el-table-column
                  prop="udi"
                  label="设备UDI"
                  >
                  <template slot-scope="scope">
                    <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-if="scope.row.realtime">
                      <div slot="content">
                        气源压力：{{scope.row.realtime.pressure}} (psi)
                        <br/>
                        冷机01   温度:{{scope.row.realtime.r01Temp}} (℃) 错误码:{{scope.row.realtime.r01ErrorCode}}
                        <br/>
                        冷机02   温度:{{scope.row.realtime.r02Temp}} (℃) 错误码:{{scope.row.realtime.r02ErrorCode}}
                      </div>
                      <router-link
                      style="text-decoration: none;color: #fff;"
                        :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id}}">
                        {{scope.row.udi}}
                      </router-link>
                    </el-tooltip>
                    <el-tooltip popper-class="tooltip-back" class="item" effect="dark" content="点击可查看设备详情" placement="top-start" v-else>
                      <router-link
                      style="text-decoration: none;color: #fff;"
                        :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id}}">
                        {{scope.row.udi}}
                      </router-link>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="registerDate"
                  label="注册日期">
                </el-table-column>
                <el-table-column
                  prop="statusText"
                  label="当前状态">
                  <template slot-scope="scope">
                    <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-if="scope.row.location">
                      <div slot="content">

                        经度：{{scope.row.location.longitude}}
                        <br/>
                        纬度：{{scope.row.location.latitude}}
                        <br/>
                        定位时间：{{scope.row.location.time}}
                        <br/>
                        <!-- 所在地：{{scope.row.provinceName}}/{{scope.row.cityName}}
                        <br /> -->
                        <div v-if="scope.row.realtime" style="margin-top: 10px;">
                          <!-- 实时数据 -->
                          <br/>
                            气源压力：{{scope.row.realtime.pressure}} (psi)
                            <br/>
                            冷机01   温度:{{scope.row.realtime.r01Temp}} (℃) 错误码:{{scope.row.realtime.r01ErrorCode}}
                            <br/>
                            冷机02   温度:{{scope.row.realtime.r02Temp}} (℃) 错误码:{{scope.row.realtime.r02ErrorCode}}
                        </div>
                      </div>
                      <span style="cursor: pointer;" >{{scope.row.statusText}}</span>
                    </el-tooltip>
                    <span v-else>{{scope.row.statusText}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="手术数据下载"
                  v-if="showActionDownload==true"
                  >
                  <template slot-scope="scope">
                    <router-link
                    class="action-button-base"
                    :to="{path:'/manage/equipment/equipment-data-download',query:{'udi':scope.row.udi}}">
                      <i class="el-icon-download"></i>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                  label="文件下载"
                  v-if="showActionDownload==true"
                  >
                  <template slot-scope="scope">
                    <router-link
                    class="action-button-base"
                    :to="{path:'/manage/equipment/equipment-file-download',query:{'udi':scope.row.udi}}">
                      <i class="el-icon-download"></i>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  >
                  <template slot="header" slot-scope="scope">
                    <el-input
                      id="search"
                      v-model="search"
                      size="mini"
                      placeholder="输入关键字搜索"/>
                  </template>
                  <template slot-scope="scope">
                    <router-link
                    v-if="showActionUpdate==true"
                    class="action-button-base"
                    :to="{path: '/manage/equipment/equipment-edit',query: {id: scope.row.id}}">
                    修改信息
                    </router-link>
                    <router-link
                    v-if="showActionUpdate==true"
                    class="action-button-base"
                    :to="{path: '/manage/equipment/equipment-bind',query: {id: scope.row.id}}">
                    账号绑定
                    </router-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
      <template>
        <!-- 各省设备分布详情 -->
        <el-dialog :visible.sync="showMoreMessages" :title="showMoreMessagesOfTitle">
          <el-table
            :data="moreTableData"
            border
            :max-height="400"
            style="width: 100%"
            @cell-click="showEquipmentDetail"
            >
            <el-table-column
              type="index"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="cityName"
              label="地区">
            </el-table-column>
            <el-table-column
              prop="hospitalName"
              label="使用单位">
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="typeModel"
              label="规格型号">
            </el-table-column>
            <el-table-column
              prop="udi"
              label="设备UDI">
            </el-table-column>
            <el-table-column
              prop="status"
              label="当前状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">正常</span>
                <span v-if="scope.row.status == 2">关机</span>
                <span v-if="scope.row.status == 3">故障</span>
                <span v-if="scope.row.status == 4">手术中</span>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showMoreMessages = false">取 消</el-button>
            <el-button type="primary" @click="exportMoreTable">导出</el-button>
          </div>
        </el-dialog>

      </template>
    </div>
</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSimplifyConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'
  import {equipmentMode} from '../../../api/equipment.js'

  export default {
    data() {
      return {
        tableHeight:0,
        search:'',
      // 设备分布
        distributionData: [],
        moreTableData:[],
        loading1:false,
        accounts:[],

        // 设备列表
        tableData:[],
        loading2:false,

        showMoreMessages:false,
        showMoreMessagesOfTitle:'',

        showBindAccounts:false,
        showBindAccountsOfTitle:'',

        // 权限
        showEquipDis:false,//统计图
        showActionAdd:false,//注册
        showActionUpdate:false,//修改
        showActionDownload:false,//下载
        showActionExport:false,//导出

        //额外
        // dialogFormVisible:false,
        // form:{
        //   name:'',
        //   region:''
        // }
      }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

      if(this.showEquipDis==true){
        this.getDistribution()
      }
      this.getEquipmentList();
    },
    created() {
      this.judgePermissions();


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)

    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      // click单元格时显示某省具体数据
      showMoreDetailConsumables(row,column,event,cell){
        this.categoryProvinceEquipment(row.provinceName);
      },
      // click单元格时显示某设备绑定账号
      // showBindAccountOfEquipment(id,udi){
      //   this.getEquipDetail(id,udi)
      // },
      getDistribution(){
        this.loading1 = true;
        this.$https.get('/stats/province')
        .then(res=>{
          this.loading1 = false;
          var obj = res.data;
          if(obj.data.provinces){
            // 获取公司库存数据
            this.distributionData = obj.data.provinces;
            areaSimplifyConversionUtil.codeToName(this.distributionData);
          }
        })
      },
      getEquipmentList(){
        this.loading2 = true;
        this.$https.get(equipmentMode.equipmentList)
        .then(res => {
          this.loading2 = false;
          var obj = res.data;
          if(obj.data.equipments){
            // 获取设备数据
            this.tableData = obj.data.equipments;
            areaSimplifyConversionUtil.codeToName(this.tableData);
          }
        })
      },
      categoryProvinceEquipment(name){
        var array = this.tableData;
        var tempArray = [];
        for (var i = 0; i < array.length; i++) {
          var obj = array[i];
          var string1 = obj.provinceName;
          var string2 = name;
          if(string1.search(string2,0) != -1){
            tempArray.push(obj);
          }
        }
        this.moreTableData = tempArray;
        this.showMoreMessages = true;
        this.showMoreMessagesOfTitle = name;
      },
      // 设备详情
      showEquipmentDetail(row) {
        this.$router.push({
          path:'/manage/equipment/equipment-details',
          query:{
            id:row.id
          },
        });
      },

      getAccountList(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/relation/accounts';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.accounts = obj.data.accounts;
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportDisTable(){
        var tableHeader = [['序号','所在地区','使用单位数量','设备数量','耗材消耗']];

        var dataList = [];
        this.distributionData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.provinceName,
            item.hospitalAmount,
            item.equipmentAmount,
            item.consumableUsedAmount
          ]);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel('设备分布',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }

      },
      exportTable(){
        var tableHeader = [['序号','所在地区','使用单位','产品名称','规格型号','设备UDI','注册日期','当前状态']];

        var dataList = [];
        this.tableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.provinceName+'/'+item.cityName,
            item.hospitalName,
            item.typeName,
            item.typeModel,
            item.udi,
            item.registerDate,
            // item.shipDate,
            item.statusText
          ]);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel('设备列表',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }

      },
      exportMoreTable(){

        var tableHeader = [['序号','地区','使用单位','产品名称','规格型号','设备UDI','当前状态']];

        var dataList = [];
        this.moreTableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.cityName,
            item.hospitalName,
            item.typeName,
            item.typeModel,
            item.udi,
            item.statusText
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.showMoreMessagesOfTitle,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      judgePermissions(){
          let equipment1 = permissionCheckUtil.findName("equipment:create");
          let equipment2 = permissionCheckUtil.findName("equipment:update");
          let equipment3 = permissionCheckUtil.findName("equipment:read");
          let equipment4 = permissionCheckUtil.findName("equipment:export");
          let equipment5 = permissionCheckUtil.findName("equipment:download");


          if(equipment1==true){
            this.showActionAdd = true;
          }
          if(equipment2==true){
            this.showActionUpdate = true;
          }
          if(equipment3==true){
            this.showEquipDis = true;
          }
          if(equipment4==true){
            this.showActionExport = true;
          }
          if(equipment5==true){
            this.showActionDownload = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          if(this.showActionAdd !== true){
            this.tableHeight = window.innerHeight-530 < 300 ? 300 :window.innerHeight-530;
          }else{
            this.tableHeight = window.innerHeight-210 < 300 ? 300 : window.innerHeight-210;
          }
        })
      }
    },

  }
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;

  .action-button{
    width: 89px;
    height: 31px;
    background: #FAFAFA;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 20px;
    background-color: #20478D;
    font-size: 14px;
    font-weight: 400;
    color: #00DEFF;
  }

  .warning-handle{
    background-color: #B26100;
    border: 1px solid rgba(255, 132, 0, 0.84);
    border-radius: 20px;
    color: #fff;
  }


  .equipment-distribution{
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;

    .distribution-list{
      margin-top: 0;
      padding-bottom: 10px;
    }
  }



  .table-content{

    .table-list{
      .hander{
        // cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }

      .action-button-base{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        display: inline-block;
        line-height: 31px;
        text-align: center;
        text-decoration: none;
      }

      .action-button-process{
        float: left;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(255, 132, 0, 0.84);
        border-radius: 20px;
        background-color: #B26100;
        font-size: 14px;
        font-weight: 400;
        color: #FFCC00;
      }

      .action-button-finish{
        float: right;
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
      }
    }
  }

    .header-common{
      // width: 1000px;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          display: inline-block;
          width: 89px;
          height: 40px;
          line-height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
          text-decoration: none;
          text-align: center;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-list.vue